<div class="empty-card-box">
    <div class="content">
        <div class="content__title">
            {{'user.hi' | translate}}, {{currentUser.firstName}}!
        </div>
        <div class="content__description">
            {{'user.initial-info' | translate}}
        </div>
    </div>

    <div class="device-add-card">
        <button (click)="onCreateModalDeviceAdd()">
            <div class="device-add-card--icon">
                <nb-icon icon="plus-outline" status="basic"></nb-icon>
            </div>
            <div class="device-add-card--text">
                {{'common.add-new-device' | translate}}
            </div>
        </button>
    </div>
</div>